import { store } from '../index';
import { showModalMessage } from '../store/modalsSlice';

export const showRowIdByCtrlClick = (e, row, title) => {
  if (e.ctrlKey) {
    const { id } = row;
    store.dispatch(showModalMessage({
      title,
      text: String(id),
    }));
  }
}


// WEBPACK FOOTER //
// ./src/common/tableActions.js